import styled, { CSSObject } from '@emotion/styled';
import merge from 'lodash.merge';
import { RED } from '@/features/theme';

interface IStyledTextareaProps {
  isInvalid?: boolean;
}

export const StyledTextarea = styled.textarea<IStyledTextareaProps>(({ isInvalid }) => {
  let styles: CSSObject = {
    display: 'block',
    width: '100%',
    padding: '8px 16px',
    border: '1px solid rgba(10, 11, 12, 0.1)',
    borderRadius: '12px',
    overflowY: 'hidden',
    resize: 'none',
    fontSize: '16px',
    lineHeight: '150%',
    boxShadow: '0px 1px 2px 0px rgba(10, 11, 12, 0.05) inset',
    ':hover': {
      borderColor: 'rgba(10, 11, 12, 0.2)',
      boxShadow: '0px 0px 0px 1px rgba(10, 11, 12, 0.2)',
    },
    ':focus': {
      borderColor: 'rgba(10, 11, 12, 0.2)',
      boxShadow: '0px 0px 0px 1px rgba(10, 11, 12, 0.2)',
    },
    '::placeholder': {
      fontSize: '16px',
      lineHeight: '150%',
    },
  };

  if (isInvalid) {
    const invalidStyles = { borderColor: RED };
    styles = merge(styles, invalidStyles);
  }

  return styles;
});
